var _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgScripts = function SvgScripts(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "-9430.461 -1734.543 19.109 24.878",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "noun_717603_cc",
    transform: "translate(-9430.461 -1734.543)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1940",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1782",
    d: "M6.633,1.239A2.188,2.188,0,0,0,4.366,3.331V24.023a2.188,2.188,0,0,0,2.267,2.093H21.21a2.187,2.187,0,0,0,2.266-2.093V8.469a2,2,0,0,0-.663-1.48l-5.56-5.136a2.349,2.349,0,0,0-1.6-.613H6.633Zm10.2,1.327,5.2,4.807H17.89A1.018,1.018,0,0,1,16.835,6.4V2.566ZM17.89,8.151h4.7a1.223,1.223,0,0,1,.046.318V24.025A1.374,1.374,0,0,1,21.21,25.34H6.633a1.375,1.375,0,0,1-1.424-1.316V3.332A1.375,1.375,0,0,1,6.633,2.017H15.65a1.536,1.536,0,0,1,.343.043V6.4A1.831,1.831,0,0,0,17.89,8.151Z",
    transform: "translate(-4.366 -1.239)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1783",
    d: "M18.492,13.562H7.823a.39.39,0,1,0,0,.777H18.491a.39.39,0,1,0,0-.777Z",
    transform: "translate(-3.602 0.683)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1784",
    d: "M7.4,10.6a.4.4,0,0,0,.421.388H18.491a.39.39,0,1,0,0-.777H7.823A.406.406,0,0,0,7.4,10.6Z",
    transform: "translate(-3.602 0.161)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1785",
    d: "M18.492,16.909H7.823a.39.39,0,1,0,0,.777H18.491a.39.39,0,1,0,0-.777Z",
    transform: "translate(-3.602 1.205)"
  })))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgScripts, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/scripts.7831b098.svg";
export { ForwardRef as ReactComponent };